var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button is-info is-light is-small is-outline is-rounded",on:{"click":function($event){return _vm.confirmDeleteUnitGroupUnit(_vm.unitGroupUnitID, _vm.name)}}},[_vm._v(" Delete ")])])}
var staticRenderFns = []

export { render, staticRenderFns }